import { render } from "./SaintRitaOfCascia.vue?vue&type=template&id=2c492b15&scoped=true"
import script from "./SaintRitaOfCascia.vue?vue&type=script&lang=js"
export * from "./SaintRitaOfCascia.vue?vue&type=script&lang=js"

import "./SaintRitaOfCascia.vue?vue&type=style&index=0&id=2c492b15&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ic-lab/ic-lab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c492b15"]])

export default __exports__